export function toMillisecondTimestamp(secondTimestamp: string | number) {
    if (!secondTimestamp) return secondTimestamp;

    const formatSecondTimestamp = Number(secondTimestamp);

    if (Number.isNaN(formatSecondTimestamp)) return secondTimestamp;

    return formatSecondTimestamp < 1e10 ? formatSecondTimestamp * 1000 : formatSecondTimestamp;
}
